import React, { useEffect, useState } from "react";
import { employeeTableHeader } from "../../../Data/data";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import {
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import "./List.css";
import { useNavigate } from "react-router-dom";
import functions from "../../../utils/Api";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchRefreshApiCallLocation,
  dispatchRefreshApiCallPermission,
  dispatchRefreshApiCallUser,
  dispatchRefreshApiCallVendor,
  dispatchUserListData,
  dispatchVendorListData,
} from "../../../Redux/dispatcher";
import { Avatar } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { FormControl } from "@mui/material";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { CircularProgress } from "@mui/material";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import UserList from "./UserList/UserList";
import VendorList from "./VendorList/VendorList";
import { setActiveTab, setLocationId } from "../../../Redux/reportSlice";
import {
  setLocationsList,
  setPermissionList,
  setUserType,
} from "../../../Redux/persistApiDataSlice";
import * as XLSX from "xlsx";

const List = () => {
  let navigate = useNavigate();
  let dispatcher = useDispatch();

  const reducerDetails = useSelector((state) => state.mealAppReducer);
  const locations = useSelector((state) => state.persistApiData.locationsList);

  const { activeTab, locationId } = useSelector((state) => state.report);

  //using the following useState to toggle the Menu item on click of the action in the useList
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [locationData, setLocationData] = useState(
    locations.length > 0 ? locations : []
  );
  const [userData, setUserData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [menuStatus, setMenuStatus] = useState(null);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetailsChanges, setUserDetailsChanges] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [totalUserCount, setTotalUserCount] = useState(0);
  const [totalVendorCount, setTotalVendorCount] = useState(0);
  const [page, setPage] = useState(0);
  const [locationFilterLoading, setLocationFilterLoading] = useState(false);

  const refreshApiCallPermission = useSelector(
    (state) => state.persistApiData.refreshApiCallPermission
  );

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  useEffect(() => {
    let updatedHeaders = [...employeeTableHeader];
    updatedHeaders[0].label =
      activeTab === "1" ? "Employee Name" : "Vendor Name";
    setTableHeaders(updatedHeaders);
  }, [activeTab]);

  useEffect(() => {
    if (reducerDetails.refreshApiCallUser) {
      try {
        functions?.get("/employee/").then((res) => {
          if (res) {
            dispatcher(dispatchUserListData(res?.data));
            dispatcher(dispatchRefreshApiCallUser(false));
          }
        });
      } catch (error) {
        console.log(error);
        dispatcher(dispatchRefreshApiCallUser(false));
      }
    }
  }, [dispatcher, reducerDetails.refreshApiCallUser]);

  useEffect(() => {
    async function getVendorData() {
      try {
        if (reducerDetails.refreshApiCallVendor) {
          await functions.get("/vendor").then((res) => {
            if (res) {
              if (res) {
                dispatcher(dispatchVendorListData(res.data));
                dispatcher(dispatchRefreshApiCallVendor(false));
                return null;
              }
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
    getVendorData();
  }, [dispatcher, reducerDetails.refreshApiCallVendor]);

  useEffect(() => {
    if (reducerDetails.refreshApiCallLocation) {
      try {
        functions
          .get("/location")
          .then((res) => {
            if (res) {
              let sortedLocationData = res?.data.sort(
                (a, b) => a.locationId - b.locationId
              );
              setLocationData(sortedLocationData ? sortedLocationData : []);
              // dispatcher(
              //   dispatchLocationsList(
              //     sortedLocationData ? sortedLocationData : []
              //   )
              // );
              dispatcher(setLocationsList(sortedLocationData));
              dispatcher(dispatchRefreshApiCallLocation(false));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }, [dispatcher, reducerDetails.refreshApiCallLocation]);

  //using the following useFfect to store and render the permissions in the dropdown
  useEffect(() => {
    if (refreshApiCallPermission) {
      try {
        functions
          .get("/permission")
          .then((res) => {
            dispatcher(setPermissionList(res.data)); // Store in the same slice
            dispatcher(dispatchRefreshApiCallPermission(false));
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    }
  }, [dispatcher, reducerDetails.refreshApiCallPermission]);

  //using the following code to show the default count of the user based on the location
  useEffect(() => {
    setLocationFilterLoading(true);
    const timeout = setTimeout(() => {
      let userCount = reducerDetails?.userListData?.filter(
        (item) => Number(item.officeLocationId) === Number(locationId)
      ).length;
      setTotalUserCount(userCount);
      setLocationFilterLoading(false);
    }, 500); // simulate loading

    return () => clearTimeout(timeout);
  }, [locationId, reducerDetails?.userListData]);

  //using the following code to show the default count of the vendor based on the location
  useEffect(() => {
    if (reducerDetails?.vendorListData) {
      setLocationFilterLoading(true);
      const timeout = setTimeout(() => {
        let count = reducerDetails?.vendorListData?.filter(
          (item) => Number(item.vendorLocationId) === Number(locationId)
        ).length;
        setTotalVendorCount(count);
        setLocationFilterLoading(false);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [locationId, reducerDetails?.vendorListData]);

  useEffect(() => {
    dispatcher(setUserType(null));
  }, [dispatcher]);

  const handleRedirect = (route) => {
    navigate("/cms/usertype");
  };

  const handleClick = (event, id) => {
    setMenuStatus(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuStatus(null);
  };

  const handleEdit = () => {
    if (menuStatus) {
      if (activeTab === "1") {
        navigate(`/cms/edit-user/${menuStatus}`);
      } else {
        navigate(`/cms/edit-vendor/${menuStatus}`);
      }
    }
  };

  const handleInactive = (user) => {
    setSelectedUser(user);
    setUserDetailsChanges(true);
  };

  const handleTabChange = (event, tabValue) => {
    dispatcher(setActiveTab(tabValue));
    setPage(0);
    setMenuStatus(null); // Reset menuStatus
    setAnchorEl(null);
    setSearchUser("");
  };

  const handleLocationChange = (event) => {
    dispatcher(setLocationId(Number(event.target.value)));
    setPage(0);
  };

  const handleSearchUser = (event) => {
    const value = event.target.value;
    setSearchUser(value);
  };

  const handleSelectedUser = (user) => {
    if (activeTab === "1") {
      navigate(`/cms/userdetails/${user.id}`);
    } else {
      navigate(`/cms/vendordetails/${user.id}`);
    }
  };

  const handleChangePassword = (row) => {
    // console.log(row);
    setAnchorEl(null);
    navigate(`/cms/reset-password/${row.id}`, { state: row.name });
  };

  const handleExport = () => {
    const isEmployeeTab = activeTab === "1";

    // ✅ Choose correct dataset
    const dataList = isEmployeeTab
      ? reducerDetails?.userListData || []
      : reducerDetails?.vendorListData || [];
    console.log("dataList", dataList);
    // ✅ Get location name from selected location
    const selectedLocation =
      locationData.find(
        (loc) => Number(loc.locationId) === Number(locationId)
      ) || {};
    const locationName =
      selectedLocation?.displayName?.toLowerCase() === "hyderabad"
        ? "Hyd"
        : selectedLocation?.displayName ||
          selectedLocation?.locationName ||
          "Location";

    // ✅ Filter data by selected location
    const filteredData = dataList.filter((item) => {
      return isEmployeeTab
        ? Number(item.officeLocationId) === Number(locationId)
        : Number(item.vendorLocationId) === Number(locationId);
    });

    // ✅ Prepare Excel data
    const exportData = filteredData.map((item) => {
      if (isEmployeeTab) {
        return {
          Name: `${item?.firstName || ""} ${item?.lastName || ""}`.trim(),
          Email: item?.email || "-",
          Location: item?.locationName?.toUpperCase() || "-",
          "Employee Type":
            item?.roleName === "contractEmployee" ? "Contract" : "Permanent",
          Status: item?.isActive ? "Active" : "Inactive",
        };
      } else {
        return {
          "Vendor Name": item?.vendorName || "-",
          Email: item?.vendorEmail || "-",
          Phone: item?.vendorPhone || "-",
          Location: item?.["Location.displayName"].toUpperCase() || "-",
          Status: item?.isActive ? "Active" : "Inactive",
        };
      }
    });

    if (exportData.length === 0) {
      alert("No data available for the selected location.");
      return;
    }

    // ✅ Format current date as DD_MON_YYYY
    const today = new Date();
    const day = today.getDate().toString().padStart(2, "0");
    const month = today
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase();
    const year = today.getFullYear();
    const formattedDate = `${day}_${month}_${year}`;

    // ✅ Create file & sheet name
    const typeLabel = isEmployeeTab ? "Users" : "Vendors";
    const fileName = `${locationName}_Meal_${typeLabel}_${formattedDate}.xlsx`;

    // ✅ Create and export workbook
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileName.replace(".xlsx", ""));
    XLSX.writeFile(wb, fileName);
  };

  const renderCell = (row, column, i) => {
    switch (column.field) {
      case "name":
        return (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
            }}
          >
            <Avatar sx={{ backgroundColor: "#004D72" }}>
              {row.name
                ?.split(" ")
                .filter((word) => word.length > 0)
                .reduce((acc, word, index, arr) => {
                  if (index === 0) {
                    // First word: Take the first letter
                    acc += word[0]?.toUpperCase();
                  }
                  if (index === arr.length - 1) {
                    // Last word: Take the first letter
                    acc += word[0]?.toUpperCase();
                  }
                  return acc;
                }, "")}
            </Avatar>
            <Typography
              sx={{
                color: "#004D72",
                fontWeight: "600",
                textDecoration: "underline",
              }}
              onClick={() => handleSelectedUser(row)}
            >
              {row.name}
            </Typography>
          </Box>
        );
      case "status":
        return (
          <Chip
            title={row.status}
            label={row.status}
            sx={{
              color: row.status === "Active" ? "#0A7D15" : "#980C11",
              backgroundColor: row.status === "Active" ? "#D0FFD8;" : "#F4D4D5",
              fontWeight: "bold",
            }}
          />
        );
      case "action":
        return (
          <Box
            key={row.id}
            className="menu-main"
            onClick={(event) => event.stopPropagation()}
          >
            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => {
                // handleMenuOpen(event, row.id);
                handleClick(event, row.id);
              }}
              sx={{
                border: "1px solid #C1C1C2",
                borderRadius: "10px",
                padding: "5px 3px",
                "&:hover": {
                  backgroundColor: "#004d72",
                  color: "#FFFFFF",
                },
              }}
            >
              <MoreVertIcon />
            </IconButton>
            {menuStatus === row.id && (
              <Box className="menu-card">
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={menuStatus === row.id && Boolean(anchorEl)}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {/* <MenuItem onClick={handleEdit}>
                    <Typography>Edit</Typography>
                  </MenuItem> */}
                  <MenuItem onClick={handleClose}>
                    <Box onClick={() => handleInactive(row)}>
                      {row?.status === "Active" ? (
                        <Typography>Inactivate</Typography>
                      ) : (
                        <Typography>Activate</Typography>
                      )}
                    </Box>
                  </MenuItem>
                  {row.status === "Active" && row?.roleId && (
                    <MenuItem onClick={() => handleChangePassword(row)}>
                      Reset Password
                    </MenuItem>
                  )}
                </Menu>
              </Box>
            )}
          </Box>
        );
      default:
        return row[column.field];
    }
  };

  return (
    <div className="Admin">
      {reducerDetails.refreshApiCallUser === false ||
      reducerDetails.refreshApiCallVendor === false ? (
        <React.Fragment>
          <Box className="Admin-breadCrumb">
            <CustomBreadcrumbs
              items={breadCrumbData}
              currentLabel="Manage Users"
            />
          </Box>
          <Box className="AdminUsersList">
            <Box className="AdminUsersList-CreateUser">
              <Box className="AdminUsersList-CreateUserMain">
                <Box className="AdminUsersList-CreateUserMain-header">
                  <Box className="AdminUsersList-titleMain">
                    <Typography variant="h5" fontWeight={700}>
                      Manage Users
                    </Typography>
                  </Box>
                  <Box className="AdminUsersList-filterMain">
                    <Box className="AdminUsersList-filterMain-roleFilter">
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="select-location-label">
                          Select Location
                        </InputLabel>
                        <Select
                          labelId="select-location-label"
                          value={Number(locationId)}
                          onChange={handleLocationChange}
                          // displayEmpty
                          startAdornment={
                            <InputAdornment position="start">
                              <RoomOutlinedIcon />
                            </InputAdornment>
                          }
                          label="Select Location"
                        >
                          {locationData.length > 0 &&
                            locationData.map((item, i) => {
                              return (
                                <MenuItem
                                  key={i}
                                  value={Number(item.locationId)}
                                >
                                  {item.displayName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </Box>
                    <Box className="AdminUsersList-filterMain-locationFilter">
                      <TextField
                        label="Search User"
                        fullWidth
                        placeholder="Search User"
                        value={searchUser}
                        onChange={handleSearchUser}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchOutlinedIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Box>
                  <Box className="AdminUsersList-CreateUserMain-createUserBtnMain">
                    {/* {activeTab === "1" ? ( */}
                    <Button
                      startIcon={<PersonAddAltOutlinedIcon />}
                      variant="contained"
                      onClick={() => handleRedirect("/cms/add-user")}
                      className="AdminUsersList-CreateUserMain-createUserBtn"
                    >
                      Create User
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{ ml: 2 }}
                      onClick={handleExport}
                      className="AdminUsersList-CreateUserMain-exportBtn"
                    >
                      Export
                    </Button>
                  </Box>
                </Box>
              </Box>
              <TabContext value={activeTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleTabChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label={`Employee (${totalUserCount})`}
                      value="1"
                      name="Employee"
                    />
                    <Tab
                      label={`Vendor (${totalVendorCount})`}
                      value="2"
                      name="Vendor"
                    />
                  </TabList>
                </Box>
                <TabPanel value="1" sx={{ padding: "unset" }}>
                  {locationFilterLoading ? (
                    <Box sx={{ textAlign: "center" }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <UserList
                      userData={userData}
                      userListData={reducerDetails.userListData}
                      vendorListData={reducerDetails.vendorListData}
                      setVendorData={setVendorData}
                      setUserData={setUserData}
                      locationId={locationId}
                      searchUser={searchUser}
                      tableHeaders={tableHeaders}
                      renderCell={renderCell}
                      loadingBtn={loadingBtn}
                      setLoadingBtn={setLoadingBtn}
                      selectedUser={selectedUser}
                      userDetailsChanges={userDetailsChanges}
                      setUserDetailsChanges={setUserDetailsChanges}
                      page={page}
                      setPage={setPage}
                    />
                  )}
                </TabPanel>
                <TabPanel value="2" sx={{ padding: "unset" }}>
                  {locationFilterLoading ? (
                    <Box sx={{ textAlign: "center" }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <VendorList
                      setUserData={setUserData}
                      vendorListData={reducerDetails.vendorListData}
                      vendorData={vendorData}
                      setVendorData={setVendorData}
                      locationId={locationId}
                      searchUser={searchUser}
                      tableHeaders={tableHeaders}
                      renderCell={renderCell}
                      loadingBtn={loadingBtn}
                      setLoadingBtn={setLoadingBtn}
                      selectedUser={selectedUser}
                      userDetailsChanges={userDetailsChanges}
                      setUserDetailsChanges={setUserDetailsChanges}
                      page={page}
                      setPage={setPage}
                    />
                  )}
                </TabPanel>
              </TabContext>
            </Box>
          </Box>
        </React.Fragment>
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
};

export default List;
